import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material";
import { ServerService } from "src/app/services/server.service";
import * as saveAs from "file-saver";
@Component({
  selector: "app-campaign-meta",
  templateUrl: "./campaign-meta.component.html",
  styleUrls: ["./campaign-meta.component.scss"],
  // encapsulation:ViewEncapsulation.None
})
export class CampaignMetaComponent implements OnInit {
  showComponentLoader = false;
  accountId: any;
  startDate: any;
  endDate: any;
  showError = false;
  constructor(
    private dialogRef: MatDialogRef<CampaignMetaComponent>,
    private _serverService: ServerService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    // console.log(this.startDate)
    // console.log(this.data)
  }
  close() {
    this.dialogRef.close();
  }
  export() {
    // console.log(String(this.startDate));
    // return;
    this.showComponentLoader = true;
    let url = "campaign_module/campaign/download_meta_campaign";
    let body = {
      campaign_id: this.data,
      // "start_date": "2025-01-01",
      account_id: this.accountId,
      start_date: String(this.startDate),
      end_date: String(this.endDate),
    };
    this._serverService.downloadZipFile(url, body).subscribe(
      (data) => {
        this.showComponentLoader = false;
        if (!data.headers.get("content-disposition")) {
          this.showError = true;
        } else {
          const contentDisposition = data.headers.get("content-disposition");
          const contentType = data.headers.get("content-type");
          const regex = /filename="([^"]+)"/;
          const match = contentDisposition.match(regex);
          saveAs(new Blob([data.body], { type: contentType }), match[1]);
        }
      },
      (err: any) => {
        this.showError = true;
        // console.error("Error exporting campaign:", err);
        this.showComponentLoader = false;
      }
    );
  }
}
